import { useToast } from '@chakra-ui/react'
import React from 'react';
import {IoMdCopy} from 'react-icons/io'
import {AiOutlineCheckCircle} from 'react-icons/ai'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { TfiWrite } from "react-icons/tfi";


const Address = () => {
  const toast = useToast();

  function CopyAlert(){
    toast({title: 'Хууллаа',status: 'success',duration: 3000,isClosable: true,})
  }

  return (
    <div className='font-Roboto mt-8 w-full'>
      <div>
          <h1 className='font-bold text-md uppercase text-xl'>Хаяг холбох</h1>
          <p>Address</p>
      </div>

      <div className='mt-8 bg-red-500 w-full p-8 rounded-md'>
        <h1 className='text-2xl text-white'>Эрээн хот</h1>
        <p className='text-gray-300 text-sm'>Эрээн хотын агуулах хаяг</p>

        <div className='mx-2 w-full text-white'>
            <div className='grid w-full justify-center text-sm'>

            <div className='mt-4'>
                    <h1>所在地区 (Бүс нутаг)</h1>
                    <div className='flex items-center mt-1'>
                        <AiOutlineCheckCircle size={18} className='mr-2'/>
                        <div className='w-52 bg-custom-gradient rounded-md py-1 px-2'>
                          <h1>
                          中国内地(大陆) хамгийн эхний 2 сонголтны зүүн талын ханзийг сонгох
N үсэгний эхний үг буюу 内蒙古自治区 ханзийг сонгох
X үсэгний эхний үг буюу 锡林郭勒盟 ханзийг сонгоно
E үсэгний эхний үг буюу 二连浩特市 ханзийг сонгоно
E үсэгний 2дахь үг буюу 二连浩特市社区建设管理局 ханзийг сонгоно
                          </h1>
                        </div>
                        <CopyToClipboard text="中国内地(大陆) 内蒙古自治区 锡林郭勒盟 二连浩特市 二连浩特市社区建设管理局">
                            <div onClick={CopyAlert} className='flex items-center cursor-pointer'>
                                <IoMdCopy size={23} />
                                <h1 className=''>copy</h1>
                            </div>
                        </CopyToClipboard>
                    </div>
                </div>
                <div className='mt-4'>
                    <h1>街道地址 (Дэлгэрэнгүй хаяг)</h1>
                    <div className='flex items-center mt-1'>
                        <AiOutlineCheckCircle size={18} className='mr-2'/>
                        <div className='w-52 bg-custom-gradient rounded-md py-1 px-2'>
                          <h1>建设管理局阿木古楞电子商务有限公司2号库 芽芽(энэ хэсэгт та өөрийн нэр утасын дугаараа бичнэ)
                          </h1>
                        </div>
                        <CopyToClipboard text="建设管理局阿木古楞电子商务有限公司2号库 芽芽(энэ хэсэгт та өөрийн нэр утасын дугаараа бичнэ)
">
                            <div onClick={CopyAlert} className='flex items-center cursor-pointer'>
                                <IoMdCopy size={23} />
                                <h1 className=''>copy</h1>
                            </div>
                        </CopyToClipboard>
                    </div>
                </div>
                <div className='mt-4'>
                    <h1>收件人 (Нэр)</h1>
                    <div className='flex items-center mt-1'>
                        <AiOutlineCheckCircle size={18} className='mr-2'/>
                        <div className='w-52 bg-custom-gradient rounded-md py-1 px-2'>
                          <h1>芽芽Apple cargo 88921400</h1>
                        </div>
                        <CopyToClipboard text="芽芽Apple cargo 88921400">
                            <div onClick={CopyAlert} className='flex items-center cursor-pointer'>
                                <IoMdCopy size={23} />
                                <h1 className=''>copy</h1>
                            </div>
                        </CopyToClipboard>
                    </div>
                </div>
                <div className='mt-4'>
                    <h1>电话 (Утас)</h1>
                    <div className='flex items-center mt-1'>
                        <AiOutlineCheckCircle size={18} className='mr-2'/>
                        <div className='w-52 bg-custom-gradient rounded-md py-1 px-2'>
                          <h1>+8615326794075</h1>
                        </div>
                        <CopyToClipboard text="+8615326794075">
                            <div onClick={CopyAlert} className='flex items-center cursor-pointer'>
                                <IoMdCopy size={23} />
                                <h1 className=''>copy</h1>
                            </div>
                        </CopyToClipboard>
                    </div>
                </div>
                <div className='mt-4'>
                    <h1>邮编 (Зип код)</h1>
                    <div className='flex items-center mt-1'>
                        <AiOutlineCheckCircle size={18} className='mr-2'/>
                        <div className='w-52 bg-custom-gradient rounded-md py-1 px-2'>
                          <h1>011000</h1>
                        </div>
                        <CopyToClipboard text="011000">
                            <div onClick={CopyAlert} className='flex items-center cursor-pointer'>
                                <IoMdCopy size={23} />
                                <h1 className=''>copy</h1>
                            </div>
                        </CopyToClipboard>
                    </div>
                </div>

            </div>
            <div className='text-sm mt-4'>
                <h1>✅Хамгийн сүүлд баруун дээд булан дээрх товчин дээр даран хамгийн доор байгаа хадгалах товчин дээр дарна🤩</h1>
                <h1>🥳Хаягаа амжилттай холбосон бол доор comment хэсэгт Screenshot хийж шалгуулаарай. 🥳</h1>
            </div>
        </div>

      </div>
      
    </div>
  )
}

export default Address
